exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userList {\n    flex-grow: 1;\n    height: 100%;\n    background: white;\n    padding: 8px;\n    overflow-y: scroll;\n}", ""]);

// exports
